module.exports = __webpack_public_path__ + "assets/00b54bee7a7c03f5e66a8b37948c0ed8.mp3";